import { ServerTransactionType } from '@wix/cashier-common/dist/src/enums/transactions/ServerTransactionType';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IPaymentMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { paymentMethodAPI } from '../utils/api/paymentMethodAPI';

export const fetchRecurringPaymentMethods = createAsyncThunk<IPaymentMethod[]>('FETCH_RECURRING_PAYMENT_METHODS', () =>
  paymentMethodAPI.fetchPaymentMethods({ chargeIntent: ServerTransactionType.Recurring }),
);
